var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE2E6;}\n\t.st1{fill:#FA5A7D;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 38.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 43,
    cy: 41.7,
    rx: 9.4,
    ry: 9.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 43,
    cy: 41.7,
    rx: 6.9,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,51.3c2.4-1,4.2-3.4,4.2-6.3c0-3.7-3.1-6.8-6.8-6.8c-3.7,0-6.8,3.1-6.8,6.8c0,3.1,2.1,5.7,4.8,6.5 c-2.2,0.6-4.1,1.9-5.5,3.7c-2.7-2.6-6.3-4-10.1-4c-3.9,0-7.6,1.5-10.4,4.3c-2.8,2.8-4.3,6.4-4.3,10.3c0,0.2,0,0.5,0,0.8l0.1,1.2 h29.3l0.1-1.2c0-0.2,0-0.5,0-0.8c0-0.9-0.1-1.8-0.2-2.6h14.3l0.1-1.2c0-0.2,0-0.4,0-0.5C71.8,56.4,68,52.2,63.1,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.2,45.1c0-2.4,2-4.3,4.3-4.3c2.4,0,4.3,2,4.3,4.3c0,2.4-2,4.3-4.3,4.3S56.2,47.4,56.2,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.7,65.3c0.3-6.4,5.7-11.5,12.2-11.5c6.6,0,11.9,5.1,12.2,11.5H30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,60.7c-0.5-1.2-1.1-2.5-2-3.5c1.5-2.1,3.9-3.5,6.6-3.5c4.1,0,7.5,3.1,7.9,7H56.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.6968aed2a33794828c61be7ac1cab235.svg";
export { ForwardRef as ReactComponent };